import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEvaluation, useExport } from '../../hooks/useEvaluation';
import { RadarChart } from '../../components/charts/RadarChart';
const CARD_STYLE = {
    position: 'relative',
    backgroundColor: '#141414',
    border: '2px solid #333333',
    borderRadius: 0,
    padding: '1rem 1.25rem',
    marginBottom: '0.75rem',
    maxWidth: '600px',
    marginLeft: 'auto',
    marginRight: 'auto',
};
const SECTION_TITLE = {
    fontWeight: '900',
    color: '#999999',
    textTransform: 'uppercase',
    letterSpacing: '0.1em',
    fontSize: '12px',
    marginBottom: '12px',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
};
const CONTENT_STYLE = {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    alignItems: 'center',
};
const HEADER_STYLE = {
    marginBottom: '0.5rem',
    textAlign: 'center',
    maxWidth: '512px',
    width: '100%',
};
const TITLE_STYLE = {
    fontSize: '1.25rem',
    fontWeight: '900',
    color: '#f5f5f5',
    textTransform: 'uppercase',
    letterSpacing: '-0.025em',
    marginBottom: '0.25rem',
};
const SUBTITLE_STYLE = {
    fontSize: '0.875rem',
    color: '#999999',
};
const BUTTON_PRIMARY = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#06b6d4',
    color: '#000000',
    fontWeight: '900',
    border: '2px solid #06b6d4',
    borderRadius: 0,
    padding: '10px 20px',
    fontFamily: 'inherit',
    fontSize: '13px',
    letterSpacing: '0.02em',
    textTransform: 'uppercase',
    transition: 'all 0.15s ease',
    cursor: 'pointer',
};
const BUTTON_SECONDARY = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    color: '#f5f5f5',
    fontWeight: '900',
    border: '2px solid #333333',
    borderRadius: 0,
    padding: '10px 20px',
    fontFamily: 'inherit',
    fontSize: '13px',
    letterSpacing: '0.02em',
    textTransform: 'uppercase',
    transition: 'all 0.15s ease',
    cursor: 'pointer',
};
export function DashboardTab() {
    const { evaluate } = useEvaluation();
    const { exportJSON, exportCSV, exportPDF } = useExport();
    const scores = evaluate();
    if (scores.length === 0) {
        return (_jsx("div", { style: CONTENT_STYLE, children: _jsxs("div", { style: HEADER_STYLE, children: [_jsx("h2", { style: TITLE_STYLE, children: "Dashboard de Resultados" }), _jsx("p", { style: SUBTITLE_STYLE, children: "Avalie modelos primeiro." })] }) }));
    }
    const topScores = scores.slice(0, 8);
    return (_jsxs("div", { style: CONTENT_STYLE, children: [_jsxs("div", { style: HEADER_STYLE, children: [_jsx("h2", { style: TITLE_STYLE, children: "Dashboard de Resultados" }), _jsx("p", { style: SUBTITLE_STYLE, children: "Baseado no seu perfil e pesos selecionados." })] }), _jsxs("div", { style: CARD_STYLE, children: [_jsx("h3", { style: SECTION_TITLE, children: "COMPARA\u00C7\u00C3O VISUAL (RADAR)" }), _jsx("div", { style: { display: 'flex', justifyContent: 'center' }, children: _jsx(RadarChart, { scores: topScores }) })] }), _jsxs("div", { style: CARD_STYLE, children: [_jsx("h3", { style: SECTION_TITLE, children: "DETALHAMENTO POR \u00CDNDICE" }), _jsx("div", { style: { overflowX: 'auto', width: '100%' }, children: _jsxs("table", { style: { width: '100%', fontSize: '12px', fontFamily: 'monospace', borderCollapse: 'collapse' }, children: [_jsx("thead", { children: _jsxs("tr", { style: { borderBottom: '2px solid #333333' }, children: [_jsx("th", { style: { textAlign: 'left', padding: '12px', color: '#999999' }, children: "#" }), _jsx("th", { style: { textAlign: 'left', padding: '12px', color: '#999999' }, children: "MODELO" }), _jsx("th", { style: { textAlign: 'left', padding: '12px', color: '#999999' }, children: "IMN" }), _jsx("th", { style: { textAlign: 'left', padding: '12px', color: '#999999' }, children: "IAP" }), _jsx("th", { style: { textAlign: 'left', padding: '12px', color: '#999999' }, children: "ICP" }), _jsx("th", { style: { textAlign: 'left', padding: '12px', color: '#999999' }, children: "IRD" }), _jsx("th", { style: { textAlign: 'left', padding: '12px', color: '#999999' }, children: "IEN" }), _jsx("th", { style: { textAlign: 'left', padding: '12px', color: '#999999' }, children: "SFP" })] }) }), _jsx("tbody", { children: scores.map((s, i) => (_jsxs("tr", { style: {
                                            borderBottom: '1px solid #33333380',
                                            backgroundColor: i < 3 ? '#1a1a1a' : 'transparent',
                                            transition: 'background-color 0.15s ease',
                                            borderLeft: i < 3 ? '4px solid #06b6d4' : 'none',
                                            paddingLeft: i < 3 ? '12px' : '0',
                                        }, onMouseEnter: (e) => {
                                            if (i >= 3)
                                                e.currentTarget.style.backgroundColor = '#1a1a1a';
                                        }, onMouseLeave: (e) => {
                                            if (i >= 3)
                                                e.currentTarget.style.backgroundColor = 'transparent';
                                        }, children: [_jsx("td", { style: { padding: '12px', color: '#06b6d4', fontWeight: '900' }, children: String(i + 1).padStart(2, '0') }), _jsx("td", { style: { padding: '12px', fontWeight: '900', color: '#f5f5f5' }, children: s.modelId }), _jsx("td", { style: { padding: '12px', color: '#999999' }, children: s.indices.imn.toFixed(1) }), _jsx("td", { style: { padding: '12px', color: '#999999' }, children: s.indices.iap.toFixed(1) }), _jsx("td", { style: { padding: '12px', color: '#999999' }, children: s.indices.icp.toFixed(1) }), _jsx("td", { style: { padding: '12px', color: '#999999' }, children: s.indices.ird.toFixed(1) }), _jsx("td", { style: { padding: '12px', color: '#999999' }, children: s.indices.ien.toFixed(1) }), _jsx("td", { style: { padding: '12px' }, children: _jsx("span", { style: { fontWeight: '900', color: '#06b6d4', fontFamily: 'monospace' }, children: s.sfp.toFixed(1) }) })] }, s.modelId))) })] }) })] })] }));
}
